/**
 * API_ENDPOINTS
 *
 * Basispfade für das ASP.NET Core Backend.
 * Alle Pfade beginnen mit /api/ – der Interceptor hängt die Backend-BaseURL davor
 * (environment.apiBaseUrl), wenn useMocks=false ist.
 *
 * Nur Endpunkte auflisten, die in der OpenAPI-Spezifikation definiert sind.
 */
export const API_ENDPOINTS = {
  // ── Check (Tag: Check / CheckComment) ──────────────────────────────────────
  // POST /check, GET|PUT /check/{id}, GET /check/{id}/document,
  // POST /check/{id}/document/{docId}, GET|POST /check/{id}/stage,
  // GET|PUT /check/{id}/stage/{stageId}, PUT /check/{id}/status,
  // GET /check/{id}/comment, GET|POST /check/{id}/stage/{stageId}/comment
  CHECK: '/api/check',

  // ── Comment (Tag: Comment) ──────────────────────────────────────────────────
  // GET|PUT /comment/{id}
  COMMENT: '/api/comment',

  // ── User / Avatar (Tag: Avatar) ─────────────────────────────────────────────
  // POST /user, GET /user/{oid}, GET|POST /user/{oid}/member,
  // GET /user/{oid}/member/{memberId}
  USER: '/api/user',

  // ── Project (Tag: Project / ProjectDocumentCheck) ───────────────────────────
  // POST /project, GET /project/{code}, GET /project/{code}/member,
  // GET|POST /project/{code}/document, GET /project/{code}/document/{docId}
  PROJECT: '/api/project',

  // ── Document (Tag: Document / DocumentCheck / DocumentComment) ──────────────
  // GET|PUT /document/{id}, GET /document/{id}/check,
  // GET|POST /document/{id}/check/{checkId},
  // GET /document/{id}/comment, POST /document/{id}/comment/{commentId}
  DOCUMENT: '/api/document',

  // ── MOCK-ONLY ────────────────────────────────────────────────────────────────
  // Folgende Endpunkte existieren NICHT in der OpenAPI-Spec.
  // Sie werden nur im Mock-Betrieb (useMocks=true) vom Interceptor bedient.
  COMMENTS:    '/api/comments',     // Legacy Mock – kein Backend-Endpunkt
  DOCUMENTS:   '/api/documents',    // Legacy Mock – kein Backend-Endpunkt
  DEPARTMENTS: '/api/departments',  // Legacy Mock – kein Backend-Endpunkt
} as const;
